import {
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
  FormArray,
} from '@angular/forms';

export function sumPercentagesValidator(key: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (!(group instanceof FormArray)) {
      return null;
    }

    if (!group.controls.length) {
      return null;
    }

    const total = group.controls
      .map((group) => +group.get(key)?.value)
      .reduce((prev, next) => prev + (next ?? 0), 0);

    if (total > 100) {
      return { upper: true };
    }

    if (total < 100) {
      return { less: true };
    }

    return null;
  };
}
